import { G1Nowifi, J1RightarrowD } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React, { useContext, useEffect, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { BannerCloseTypes, BannerKey } from '../../banners/types'
import OfflineInstallationHelpModal from './OfflineInstallationHelpModal'
import { InstallationOnlineStatusContext } from 'src/Libs/installations/context/installation-online-status-context'
import { useFarmContext } from 'src/Elements/Farm'
import { useParams } from 'react-router-dom'
import { Button } from '@mui/material'
import { Banner } from 'src/Components/banner'
import { useBannerContext } from 'src/Libs/banners'

const useStyles = makeStyles()(theme => ({
  containerStyle: {
    backgroundColor: theme.palette.error.light,
  },
  noWifiIcon: {
    fontSize: 30,
    color: theme.palette.error.main,
  },
  helpButton: {
    boxShadow: 'none',
    width: 'max-content',
    marginLeft: 'auto',
    paddingLeft: theme.spacing(4),

    '&:hover': {
      boxShadow: theme.effectStyles.shadowMain,
    },

    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
  },
}))

/**
 * This is a banner that is shown if an installation is offline OR if the installation is a farm and at least of of its clients is offline
 */
const OfflineInstallationBanner: React.FC<{ isServiceView: boolean }> = ({ isServiceView }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()
  const { isFarm, isFarmMasterSelected } = useFarmContext()
  const { removeBanner } = useBannerContext()
  const { childStorageId } = useParams<{ installationId: string; storageId: string; childStorageId: string }>()
  const { isStorageOnline, areAllClientsOnline } = useContext(InstallationOnlineStatusContext)
  const [showHelpModal, setShowHelpModal] = useState(false)
  const isOnlineFarmClient = isFarm && isStorageOnline && (childStorageId || !isFarmMasterSelected)
  const isOnlineFarmServer = isFarm && isFarmMasterSelected && isStorageOnline
  const infoTextI18nKey = isServiceView
    ? 'systemSettings.offline-installation-banner.info-text-service-view'
    : isOnlineFarmServer && !areAllClientsOnline
    ? 'systemSettings.offline-installation-banner.info-text-farm'
    : 'systemSettings.offline-installation-banner.info-text'

  useEffect(() => {
    if (isOnlineFarmClient) {
      // Remove banner from the queue, but not hide it in DOM! Otherwise the user can't access the next banner in the queue.
      removeBanner(BannerKey.OfflineInstallationBanner)
    }
  }, [isOnlineFarmClient, removeBanner])

  return (
    <>
      <Banner
        i18nKey={infoTextI18nKey}
        icon={<G1Nowifi className={classes.noWifiIcon} />}
        button={
          isServiceView ? undefined : (
            <Button className={classes.helpButton} color="error" variant="contained" onClick={() => setShowHelpModal(true)}>
              {t('systemSettings.offline-installation-banner.main-button')}
              <J1RightarrowD />
            </Button>
          )
        }
        bannerKey={BannerKey.OfflineInstallationBanner}
        closeType={BannerCloseTypes.Temporary}
        containerStyle={classes.containerStyle}
      />
      <OfflineInstallationHelpModal isVisible={showHelpModal} handleClose={() => setShowHelpModal(false)} />
    </>
  )
}

export default OfflineInstallationBanner
